/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

export const LOCAL_STORAGE = {
  token: "token",
  refreshingToken: "refreshingToken",
};
